<template>
    <div style="padding-left: 50px;background: #ffffff">
    <el-carousel :interval="5000" arrow="always" style="height: 412px;width: 1100px">
        <el-carousel-item style="height: 100%">
            <img src="@/assets/image/home/home-banner.png" style="width: 100%;height: 100%">
        </el-carousel-item>
        <el-carousel-item style="height: 100%">
            <img src="@/assets/image/home/home-banner3.png" style="width: 100%;height: 100%">
        </el-carousel-item>
    </el-carousel>
    </div>
</template>

<script>
    export default {
        name: "bannaner"
    }
</script>

<style>
    .el-carousel__item h3 {
        color: #475669;
        font-size: 18px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }
    .el-carousel__container{
        height: 412px !important;
    }
</style>